<template>
  <div class="t-history">
    <h2 class="t-history__title" :class="{_open: open === 1}" @click.prevent="Open(1)">{{ pageText.title_1 }} — {{ history.waiting.length }} <span></span></h2>
    <div class="t-history__list" v-show="open === 1">

      <cmp-lesson class="t-history-lesson" v-for="(item, index) in history.waiting" :key="'waiting_' + index" :data="item"></cmp-lesson>
    </div>
    <h2 class="t-history__title" :class="{_open: open === 2}" @click.prevent="Open(2)">{{ pageText.title_2 }} — {{ history.confirmed.length }} <span></span></h2>
    <div class="t-history__list" v-show="open === 2">
      <cmp-lesson class="t-history-lesson" v-for="(item, index) in history.confirmed" :key="'confirmed_' + index" :data="item"></cmp-lesson>
    </div>
    <h2 class="t-history__title" :class="{_open: open === 3}" @click.prevent="Open(3)">{{ pageText.title_3 }} — {{ history.end.length }} <span></span></h2>
    <div class="t-history__list" v-show="open === 3">
      <cmp-lesson class="t-history-lesson" v-for="(item, index) in history.end" :key="'end_' + index" :data="item"></cmp-lesson>
    </div>
  </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/courseHistory.json' : 'staticText',
        main: {
            title_1: "Активные заявки",
            title_2: "Активные записи",
            title_3: "Ожидает оценки"
        }
    };

    import {store} from '../../../store/index'

    import {mapGetters, mapActions} from 'vuex'

    import Lesson from '../../../vue_components/Lesson.vue'

    export default {
        components: {
            'cmp-lesson': Lesson
        },
        data(){
            return {
                open: -1,
                pageText: {}
            }
        },
        computed: {
            ...mapGetters('coursesList', ['history', 'course'])
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            Open(index){
                this.open = this.open === index ? -1 : index;
            },
            Load(pageText){
                this.pageText = pageText;
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            }
        },
        beforeRouteLeave (to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
        beforeRouteEnter (to, from, next) {
            let count = 0;

            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });

            store.dispatch('staticText/LoadReviewText').then(() => {count++;RunNext();});
            store.dispatch('coursesList/LoadHistory', {id: to.params.id}).then((e) => {
                if(e){
                    count++;
                    RunNext();
                }
                else
                    next({ name: 'courses_info', params: {id: to.params.id}});
            });
            let RunNext = () => {
                if(count > 2)
                    next(vm => vm.Load(pageText))
            }
        }
    }
</script>

<style lang="sass">
.t-history
  &__title
    display: flex
    align-items: center
    justify-content: space-between
    padding: 16px 22px
    @extend %substrate
    color: $blue
    font-size: 22px
    margin-bottom: 32px
    cursor: pointer
    span
      width: 40px
      height: 40px
      background: url('/img/select.png') no-repeat center
      transition: transform .2s
    &._open
      span
        transform: scale(1, -1)
  &__list
    display: flex
    align-items: flex-start
    justify-content: flex-start
    flex-wrap: wrap
    margin: -8px 0 8px

.t-history-lesson
  width: 304px
  @extend %substrate
  padding: 24px
  margin: 0 24px 24px 0
</style>


// WEBPACK FOOTER //
// src/vue_pages/Courses/View/History.vue